const origin = window ? window.location.origin.toString() : '';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CASCADE_URL = process.env.REACT_APP_CASCADE_URL;
export const CLIENT_ID = process.env.CASCADE_AUTH_CLIENT_ID;
export const GRANT_TYPE = process.env.REACT_APP_GRANT_TYPE;
export const AUTH_CALLBACK_URI = process.env.AUTH_CALLBACK_URI;
export const SEGMENT_WRITE_KEY = process.env.SEGMENT_WRITE_KEY;
export const SEGMENT_INTEGRATION_ID = "integOutlook_v1";
